import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import LightModeIcon from '@mui/icons-material/LightMode';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import { useBranding } from '@/lib/branding';

const ThemeModeToggle = ({ size = 'medium', edge }) => {
  const { mode, toggleMode } = useBranding();
  const isDark = mode === 'dark';
  const label = isDark ? 'Switch to light mode' : 'Switch to dark mode';

  return (
    <Tooltip title={label}>
      <IconButton
        size={size}
        edge={edge}
        onClick={toggleMode}
        aria-label={label}
        data-testid="theme-mode-toggle"
        sx={{ color: 'text.primary' }}
      >
        {isDark ? <LightModeIcon fontSize="small" /> : <DarkModeIcon fontSize="small" />}
      </IconButton>
    </Tooltip>
  );
};

export default ThemeModeToggle;
